export const ROLE_LABELS = {
  manager: "Manager",
  people_ops: "People Operations",
  leadership: "Executive Leadership",
};

// tone: green | amber | red | neutral
const STATUS_META = {
  feedback_logged: { label: "Feedback logged", tone: "neutral" },
  entry_requested: { label: "Entry requested", tone: "amber" },
  entry_approved: { label: "Entry approved", tone: "green" },
  entry_rejected: { label: "Entry rejected", tone: "red" },
  plan_submitted: { label: "Plan submitted", tone: "amber" },
  plan_rejected: { label: "Plan rejected", tone: "red" },
  plan_active: { label: "Plan active", tone: "green" },
  in_checkins: { label: "In check-ins", tone: "green" },
  decision_pending: { label: "Decision pending", tone: "amber" },
  closed: { label: "Closed", tone: "neutral" },
};

export function statusMeta(status) {
  return STATUS_META[status] || { label: status, tone: "neutral" };
}

export const OUTCOME_META = {
  met: { label: "Met", tone: "green" },
  extended: { label: "Extended", tone: "amber" },
  not_met: { label: "Not Met", tone: "red" },
};

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? iso + "T00:00:00" : iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

// lightweight client-side specificity hints (server enforces the real rules)
const DATE_RE = /(\b\d{1,2}[/-]\d{1,2}([/-]\d{2,4})?\b)|(\b\d{4}-\d{1,2}-\d{1,2}\b)|(\b(jan|feb|mar|apr|may|jun|jul|aug|sep|sept|oct|nov|dec)[a-z]*\.?\s+\d{1,2}\b)|(\bweek of\b)/i;
const VAGUE = ["poor communication", "needs better quality", "not a team player", "attitude problem", "poor attitude", "lazy", "unprofessional", "needs improvement", "be better", "tbd", "n/a"];

export function specificityCheck(text, { minLen = 40, requireDate = false } = {}) {
  const t = (text || "").trim();
  const low = t.toLowerCase();
  const longEnough = t.length >= minLen;
  const hasDate = DATE_RE.test(t);
  const notVague = !VAGUE.some((v) => low === v || (low.length < 30 && low.startsWith(v)));
  const dateOk = requireDate ? hasDate : true;
  return { longEnough, hasDate, notVague, dateOk, ok: longEnough && notVague && dateOk, length: t.length };
}
